"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateReactor = exports.updateFire = void 0;
var settings_sidecar_1 = require("@engine/settings-sidecar");
var soundsGeneric_sidecar_1 = require("@engine/soundsGeneric-sidecar");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var voyageSounds_sidecar_1 = require("@voyage/sounds/voyageSounds-sidecar");
function play(keys, volume, loop, cb) {
    return soundsGeneric_sidecar_1.soundsGeneric.playAmbientUnmanaged(voyageSounds_sidecar_1.voyageSounds.getMusicPath() + rando_sidecar_1.rando.sample(keys), volume, loop, cb);
}
var _fire = null;
//let _fireId: number = -1
function updateFire(doPlay) {
    if (settings_sidecar_1.settings.get().muteSound) {
        doPlay = false;
    }
    // console.log('update fire', doPlay)
    if (doPlay) {
        // console.log('do play', doPlay)
        if (_fire) {
            return;
        }
        console.log('play buring');
        _fire = play(['FireBurningLoop1', 'FireBurningLoop2'], //, 'FireBurningLoop3'],
        0.8, false, function () {
            console.log('fire looped');
            soundsGeneric_sidecar_1.soundsGeneric.stopAmbientUnmanaged(_fire);
            _fire = null;
        });
    }
    else {
        // console.log('stop buring')
        soundsGeneric_sidecar_1.soundsGeneric.stopAmbientUnmanaged(_fire);
        _fire = null;
    }
}
exports.updateFire = updateFire;
var _reactor = null;
function updateReactor(doPlay) {
    if (settings_sidecar_1.settings.get().muteSound) {
        doPlay = false;
    }
    // console.log('update fire', doPlay)
    if (doPlay) {
        // console.log('do play', doPlay)
        if (_reactor) {
            return;
        }
        _reactor = play([
            'SpaceShip_EngineRoom_01_Loop',
            'SpaceShip_EngineRoom_01_Variation_Loop',
        ], 1.5, false, function () {
            soundsGeneric_sidecar_1.soundsGeneric.stopAmbientUnmanaged(_reactor);
            _reactor = null;
        });
    }
    else {
        soundsGeneric_sidecar_1.soundsGeneric.stopAmbientUnmanaged(_reactor);
        _reactor = null;
    }
}
exports.updateReactor = updateReactor;
// function playManaged(keys: string[]) {
//   soundsGeneric.playAmbient(voyageSounds.getMusicPath() + rando.sample(keys))
// }
// export function playInSpace() {
//   playManaged(
//     ['SpaceShip_EngineRoom_01_Loop', 'SpaceShip_EngineRoom_01_Variation_Loop'],
//     //1,
//     //false,
//   )
// }
